import {
  EmailTemplateDto,
  EmailTemplateModel,
  mapEmailTemplateDtoToModel,
} from 'api/dto/EmailTemplate.dto';

export type EmailDistributionDto = {
  id: string;
  slug: string;
  invitation?: EmailTemplateDto;
  reminders?: EmailTemplateDto[];
};

export type EmailDistributionModel = {
  id: string;
  slug: string;
  invitation?: EmailTemplateModel;
  reminders?: EmailTemplateModel[];
};

export function mapEmailDistributionDtoToModel(dto: EmailDistributionDto): EmailDistributionModel {
  return {
    id: dto.id,
    slug: dto.slug,
    invitation: dto.invitation ? mapEmailTemplateDtoToModel(dto.invitation) : null,
    reminders: (dto.reminders || []).map(mapEmailTemplateDtoToModel),
  };
}
